"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ROOT_URL = "https://apis.voicebase.com/";

var _default = function _default(token, mediaId, baseUrl, accountId) {
  if (baseUrl === void 0) {
    baseUrl = "v3";
  }

  if (!/^http/.test(baseUrl)) {
    baseUrl = ROOT_URL + baseUrl;
  }

  var url = baseUrl + "/media/" + mediaId + "/streams";
  return _axios["default"].get(url, {
    headers: _extends({
      Authorization: "Bearer " + token
    }, accountId && {
      "VoiceBase-Account-ID": accountId
    })
  }).then(function (response) {
    var streamURL = null;

    if (response.data && response.data.streams) {
      // V3 has a different format...this code needs to be in a better spot...
      var streams = response.data.streams;

      if (streams.length) {
        // v3 - streams is Array<{streamName:string, steramLocation:string}>
        var sources = streams.reduce(function (returnObject, stream) {
          var _Object$assign;

          Object.assign(returnObject, (_Object$assign = {}, _Object$assign[stream.streamName] = stream.streamLocation, _Object$assign));
          return returnObject;
        }, {});
        streamURL = sources.redacted || sources.original || streamURL;
      } else {
        // v2 - streams is string
        streamURL = streams.audio || streams.original || streamURL;
      }
    }

    return streamURL;
  });
};

exports["default"] = _default;